// SeoHead - Direct DOM meta tag management
// Replaces react-helmet-async which has known issues in v2 with meta tags
import { useEffect } from 'react';

function setMetaTag(attr, attrValue, content) {
  let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, attrValue);
    el.setAttribute('data-seo-meta', 'true');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLinkTag(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"][data-seo-meta]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    el.setAttribute('data-seo-meta', 'true');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function SeoHead({ title, description, keywords, canonical, og, twitter, geo, schemas }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMetaTag('name', 'description', description);
    if (keywords) setMetaTag('name', 'keywords', keywords);
    if (canonical) setLinkTag('canonical', canonical);

    if (og) {
      if (og.type) setMetaTag('property', 'og:type', og.type);
      if (og.url) setMetaTag('property', 'og:url', og.url);
      if (og.title) setMetaTag('property', 'og:title', og.title);
      if (og.description) setMetaTag('property', 'og:description', og.description);
      if (og.image) setMetaTag('property', 'og:image', og.image);
      if (og.siteName) setMetaTag('property', 'og:site_name', og.siteName);
    }

    if (twitter) {
      if (twitter.card) setMetaTag('name', 'twitter:card', twitter.card);
      if (twitter.title) setMetaTag('name', 'twitter:title', twitter.title);
      if (twitter.description) setMetaTag('name', 'twitter:description', twitter.description);
      if (twitter.image) setMetaTag('name', 'twitter:image', twitter.image);
    }

    if (geo) {
      if (geo.region) setMetaTag('name', 'geo.region', geo.region);
      if (geo.placename) setMetaTag('name', 'geo.placename', geo.placename);
      if (geo.position) setMetaTag('name', 'geo.position', geo.position);
      if (geo.icbm) setMetaTag('name', 'ICBM', geo.icbm);
    }

    return () => {
      document.querySelectorAll('[data-seo-meta]').forEach(el => el.remove());
    };
  }, [title, description, keywords, canonical, og, twitter, geo]);

  useEffect(() => {
    if (!schemas?.length) return;
    const els = schemas.map(schema => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-schema', 'true');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      return script;
    });
    return () => els.forEach(el => el.remove());
  }, [schemas]);

  return null;
}
